import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@shared/design-system/styles/global.css'
import { App } from '@app/App'
import { enableMocking } from './mocks/enable'

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Elemento #root não encontrado no documento.')
}

const root = createRoot(rootElement)

void enableMocking().then(() => {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
})
